export default __webpack_public_path__ + "static/media/o.7938f6a6.svg";